import styled from 'styled-components';

const ToggleIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
`;

export default ToggleIcon;